
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class WLPrice extends Vue {
  @Prop()
  private price!: number;

  @Prop({ default: false })
  private isPageBankImprintMobile!: boolean;

  get priceParts(): [{ type: string; value: string }] {
    return this.$options.filters && this.$options.filters.formatPrice(this.price, undefined, true);
  }
}
